import ReactCalender from '../../common/Datepicker';
import Input from '../../common/Input';
import { useEffect } from 'react';
import { getUnitPrice } from '../../../utils/helpers/formula';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../common/Checkbox';

const ModalProhibited = (props) => {
    const { t } = useTranslation();
    const { formData, setFormData } = props;

    const {
        jan,
        itemName,
        deleteFlag,
        startDate,
        endDate,
        lowerLimit,
        lowerLimitUnit,
        sellingPrice,
        sellingUnitPrice,
        quantityOfUnit,
        unit,
    } = formData;

    useEffect(() => {
        handleChangeOnBlur('lowerLimit', lowerLimit);
        handleChangeOnBlur('sellingPrice', sellingPrice);
    }, []);

    const handleChangeState = (field, value) => {
        setFormData((formData) => ({
            ...formData,
            [field]: value,
        }));
    };

    const handleChangeOnBlur = (field, value) => {
        if (field === 'lowerLimit') {
            setFormData((formData) => ({
                ...formData,
                lowerLimitUnit: getUnitPrice(value, formData.capacityOfUnit, formData.quantityOfUnit),
            }));
        } else {
            setFormData((formData) => ({
                ...formData,
                sellingUnitPrice: getUnitPrice(value, formData.capacityOfUnit, formData.quantityOfUnit),
            }));
        }
    };

    return (
        <div className="okc-modal__body modal-body">
            <h5 className="mb-2">{t('prohibited_product_list.edit_modal.product_information')}</h5>
            <div className="okc-card okc-result-form mb-5">
                <div className="okc-card__body">
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('prohibited_product_list.edit_modal.jan')}</p>
                        </div>
                        <div className="col-lg-8 offset-lg-1">{jan}</div>
                    </div>
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('prohibited_product_list.edit_modal.product_name')}</p>
                        </div>
                        <div className="col-lg-8 offset-lg-1">{itemName}</div>
                    </div>
                </div>
            </div>
            <h5 className="mb-2">{t('prohibited_product_list.edit_modal.disable_setting')}</h5>
            <div className="okc-card okc-result-form">
                <div className="okc-card__body">
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('prohibited_product_list.edit_modal.status.title')}</p>
                        </div>
                        <div className="col-lg-8 offset-lg-1 flex-column">
                            <div className="row no-gutters w-100">
                                <Checkbox
                                    column="col-xl-3 col-lg-4 col-md-5"
                                    label={t('prohibited_product_list.edit_modal.status.label')}
                                    onChange={() => handleChangeState('deleteFlag', !deleteFlag)}
                                    value={deleteFlag}
                                    checked={!deleteFlag} // 表示は反転させる
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p className="mb-0">{t('prohibited_product_list.edit_modal.start_date')}</p>
                        </div>
                        <div className="col-8 offset-lg-1 flex-column align-items-start">
                            <ReactCalender
                                minDate={new Date()}
                                classNameInputDateTime="form-control--input-max-120"
                                value={startDate}
                                placeholder={t('prohibited_product_list.edit_modal.start_date')}
                                onChange={(value) => {
                                    handleChangeState('startDate', value);

                                    // 開始日が終了日以降になる場合は終了日をクリア
                                    if (value > endDate) {
                                        handleChangeState('endDate', '');
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p className="mb-0">{t('prohibited_product_list.edit_modal.end_date')}</p>
                        </div>
                        <div className="col-8 offset-lg-1 flex-column align-items-start">
                            <ReactCalender
                                minDate={startDate ? new Date(startDate) : new Date()}
                                classNameInputDateTime="form-control--input-max-120"
                                value={endDate}
                                placeholder={t('prohibited_product_list.edit_modal.end_date')}
                                onChange={(value) => {
                                    handleChangeState('endDate', value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('prohibited_product_list.edit_modal.lower_limit')}</p>
                        </div>
                        <div className="col-lg-8 offset-lg-1 d-flex">
                            <div className="row no-gutters w-100">
                                <div className="col-xl-6 align-items-start mb-2 mb-xl-0 d-flex flex-column">
                                    <p className="mb-2">{t('prohibited_product_list.edit_modal.excluding_tax')}</p>
                                    <div className="row no-gutters w-100 flex-xl-nowrap">
                                        <div className="col-4 flex-column">
                                            <Input
                                                name="lowerLimit"
                                                type="text"
                                                autocomplete="off"
                                                maxLength="6"
                                                className="form-control form-control--input"
                                                value={lowerLimit}
                                                onChange={(value) => handleChangeState('lowerLimit', value)}
                                                onKeyUp={(value) => handleChangeOnBlur('lowerLimit', value)}
                                                onBlur={(value) => handleChangeOnBlur('lowerLimit', value)}
                                            />
                                        </div>
                                        <div className="col-1 align-items-start">
                                            <p className="m-0 w-100 text-center mt-2">{t('card_fresshness_registration.circle')}</p>
                                        </div>
                                    </div>
                                    <p className="my-2">{t('card_registration.price.excluding_tax.unit_title')}</p>
                                    <div className="row no-gutters w-100 flex-xl-nowrap">
                                        <div className="col-4 flex-column">
                                            <Input
                                                className="form-control form-control--input form-control--disabled"
                                                value={lowerLimitUnit}
                                                type="text"
                                                disabled={true}
                                                autocomplete="off"
                                                readonly="readonly"
                                            />
                                        </div>
                                        <div className="col-1 align-items-start">
                                            <p className="m-0 w-100 text-center mt-2">{t('card_registration.circle')}</p>
                                        </div>
                                        <div className="col-4 flex-column">
                                            <Input
                                                className="form-control form-control--input form-control--readonly result__price"
                                                name="unit"
                                                type="text"
                                                readonly="readonly"
                                                autocomplete="off"
                                                value={`${quantityOfUnit} ${unit}`}
                                                disabled
                                            />
                                        </div>
                                        <div className="col-auto align-items-start"></div>
                                        <div className="col-1"></div>
                                    </div>
                                </div>
                                <div className="col-xl-6 align-items-start mb-2 mb-xl-0 d-flex flex-column">
                                    <p className="mb-2">{t('prohibited_product_list.edit_modal.headquarters_price')}</p>
                                    <div className="row w-100 flex-xl-nowrap">
                                        <div className="col-4 flex-column">
                                            <Input
                                                className="form-control form-control--input form-control--disabled"
                                                value={sellingPrice}
                                                type="text"
                                                disabled={true}
                                                autocomplete="off"
                                                onBlur={(value) => handleChangeOnBlur('sellingPrice', value)}
                                            />
                                        </div>
                                        <div className="col-1 align-items-start">
                                            <p className="m-0 w-100 text-center mt-2">{t('card_fresshness_registration.circle')}</p>
                                        </div>
                                    </div>
                                    <p className="my-2">{t('card_registration.price.including_tax.unit_title')}</p>
                                    <div className="row w-100 flex-xl-nowrap">
                                        <div className="col-4 flex-column">
                                            <Input
                                                className="form-control form-control--input form-control--readonly result__tax-price"
                                                type="text"
                                                name="sellingUnitPriceTax"
                                                placeholder={t('card_registration.placeholder.unit_price')}
                                                readonly="readonly"
                                                autocomplete="off"
                                                value={sellingUnitPrice}
                                                disabled
                                            />
                                        </div>
                                        <div className="col-1 align-items-start">
                                            <p className="m-0 w-100 text-center mt-2">{t('card_registration.circle')}</p>
                                        </div>
                                        <div className="col-4 flex-column">
                                            <Input
                                                className="form-control form-control--input form-control--readonly result__tax-price"
                                                type="text"
                                                name="unitTax"
                                                readonly="readonly"
                                                autocomplete="off"
                                                value={`${quantityOfUnit} ${unit}`}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ModalProhibited;
